// import React, { useEffect, useState } from "react";
// import { Link, useNavigate } from "react-router-dom";
// import { FaPlus } from "react-icons/fa";
// import {
//   Modal,
//   Button,
//   Form,
//   Table,
//   Pagination,
//   Row,
//   Col,
//   Container,
//   Spinner,
// } from "react-bootstrap";
// import { FaEdit } from "react-icons/fa";
// import { RiDeleteBin3Fill, RiFilter2Line } from "react-icons/ri";
// import { HiOutlineChevronLeft, HiChevronRight } from "react-icons/hi2";
// import { BsThreeDots } from "react-icons/bs";
// import { MdFilterAlt } from "react-icons/md";
// import { MdFilterAltOff } from "react-icons/md";
// import { FaDownload } from "react-icons/fa";
// import * as XLSX from "xlsx";

// const API_URL = process.env.REACT_APP_API_URL;

// function ExpensesList() {
//   const navigate = useNavigate();
//   const [expenses, setExpenses] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [dataLoading, setDataLoading] = useState(true);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [totalPages, setTotalPages] = useState(1);
//   const [searchQuery, setSearchQuery] = useState("");
//   const [editModalShow, setEditModalShow] = useState(false);
//   const [exporting, setExporting] = useState(false);
//   const [limit, setLimit] = useState(10);

//   // Edit form data में project और plot fields जोड़ें
//   const [editFormData, setEditFormData] = useState({
//     id: "",
//     category_id: "",
//     category_name: "",
//     account_id: "",
//     payee: "",
//     type: "",
//     name: "",
//     amount: "",
//     date: "",
//     description: "",
//     project_id: "", // नया
//     project_name: "", // नया
//     plot_id: "", // नया
//     plot_name: "", // नया
//   });

//   const [deleteModalShow, setDeleteModalShow] = useState(false);
//   const [expenseToDelete, setExpenseToDelete] = useState(null);
//   const [categories, setCategories] = useState([]);
//   const [bankAccounts, setBankAccounts] = useState([]);
//   const [fillterdesign, setfillterdesign] = useState();

//   // Projects और Plots के लिए state
//   const [projects, setProjects] = useState([]);
//   const [plots, setPlots] = useState([]);
//   const [filteredPlots, setFilteredPlots] = useState([]);

//   const formatText = (text) => {
//     if (!text || typeof text !== "string") return "NA";
//     return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
//   };

//   const [searchTerm, setSearchTerm] = useState({
//     name: "",
//     category: "",
//     payee: "",
//     type: "",
//     amount: "",
//     fromdate: "",
//     todate: "",
//   });

//   const getAuthToken = () => {
//     return localStorage.getItem("token");
//   };

//   const [showMessageModal, setShowMessageModal] = useState(false);
//   const [messageModalContent, setMessageModalContent] = useState({
//     title: "",
//     text: "",
//     type: "",
//   });

//   const showCustomMessageModal = (title, text, type) => {
//     setMessageModalContent({ title, text, type });
//     setShowMessageModal(true);
//   };

//   const closeCustomMessageModal = () => {
//     setShowMessageModal(false);
//   };

//   // Projects fetch करें
//   const fetchProjects = async () => {
//     const token = getAuthToken();
//     if (!token) return;

//     try {
//       const projectsResponse = await fetch(`${API_URL}/project-list-block`, {
//         method: "GET",
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${token}`,
//         },
//       });

//       const projectsData = await projectsResponse.json();

//       if (projectsData.status) {
//         setProjects(projectsData.data || []);
//       }
//     } catch (err) {
//       console.error("Error fetching projects:", err);
//       showCustomMessageModal("Error", "Failed to load projects", "error");
//     }
//   };

//   // Selected project के based पर plots fetch करें
//   const fetchPlotsByProject = async (projectId) => {
//     if (!projectId) {
//       setFilteredPlots([]);
//       return;
//     }

//     const token = getAuthToken();
//     if (!token) return;

//     try {
//       const plotsResponse = await fetch(
//         `${API_URL}/all-plot-list-by-id?project_id=${projectId}`,
//         {
//           method: "GET",
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${token}`,
//           },
//         },
//       );

//       const plotsData = await plotsResponse.json();

//       if (plotsData.status) {
//         const allPlots = plotsData.data || [];
//         setFilteredPlots(allPlots);
//       } else {
//         setFilteredPlots([]);
//       }
//     } catch (err) {
//       console.error("Error fetching plots:", err);
//       showCustomMessageModal("Error", "Failed to load plots", "error");
//     }
//   };

//   const fetchExpenses = async (page = 1) => {
//     const token = getAuthToken();
//     if (!token) {
//       showCustomMessageModal(
//         "Auth Error",
//         "Authentication token not found. Please log in.",
//         "error",
//       );
//       setLoading(false);
//       setDataLoading(false);
//       return;
//     }
//     setLoading(true);
//     try {
//       const query = new URLSearchParams({
//         page,
//         name: searchTerm.name,
//         payee: searchTerm.payee,
//         category: searchTerm.category,
//         type: searchTerm.type,
//         amount: searchTerm.amount,
//         fromdate: searchTerm.fromdate,
//         todate: searchTerm.todate,
//       }).toString();

//       const response = await fetch(`${API_URL}/expence-list?${query}`, {
//         method: "GET",
//         headers: { Authorization: `Bearer ${token}` },
//       });

//       if (!response.ok) {
//         throw new Error("Failed to fetch expenses.");
//       }
//       const data = await response.json();
//       if (data.status) {
//         setExpenses(data.data);
//         setTotalPages(data.totalPages || 1);
//         setCurrentPage(data.currentPage || page);
//       } else {
//         showCustomMessageModal("Error", data.message, "error");
//       }
//     } catch (error) {
//       console.error("Failed to fetch expenses:", error);
//       showCustomMessageModal(
//         "Network Error",
//         "Could not connect to the server.",
//         "error",
//       );
//     } finally {
//       setLoading(false);
//       setDataLoading(false);
//     }
//   };

//   // Export function (same as before)
//   const exportAllToExcel = async () => {
//     setExporting(true);
//     try {
//       const token = getAuthToken();
//       if (!token) {
//         showCustomMessageModal(
//           "Authentication Error",
//           "Authentication token not found. Please log in.",
//           "error",
//         );
//         return;
//       }

//       let url = `${API_URL}/expense-download`;
//       const response = await fetch(url, {
//         method: "GET",
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${token}`,
//         },
//       });

//       if (!response.ok) {
//         const errorData = await response.json();
//         showCustomMessageModal(
//           "Error",
//           errorData.message || "Failed to fetch associates.",
//           "error",
//         );
//         return;
//       }

//       const data = await response.json();
//       const allAssociates = data.data || [];
//       const worksheet = XLSX.utils.json_to_sheet(
//         allAssociates.map((associate) => ({
//           "SL No.": allAssociates.indexOf(associate) + 1,
//           Name: associate.name,
//           "Category Name": associate.category_name,
//           Payee: associate.payee,
//           Type: associate.type,
//           Amount: associate.amount,
//           Description: associate.description,
//           Date: associate.date,
//           Project: associate.project_name,
//           Plot: associate.plot_name,
//         })),
//       );

//       const workbook = XLSX.utils.book_new();
//       XLSX.utils.book_append_sheet(workbook, worksheet, "Expenses");
//       XLSX.writeFile(
//         workbook,
//         `All_Expenses_${new Date().toISOString().split("T")[0]}.xlsx`,
//       );
//     } catch (err) {
//       console.error("Export error:", err);
//       showCustomMessageModal("Error", "Failed to export expenses.", "error");
//     } finally {
//       setExporting(false);
//     }
//   };

//   const handleSearch = (e) => {
//     e.preventDefault();
//     fetchExpenses(1);
//   };

//   const fetchDropdownData = async () => {
//     const token = getAuthToken();
//     if (!token) return;

//     try {
//       const [categoriesResponse, bankAccountsResponse] = await Promise.all([
//         fetch(`${API_URL}/expence-category-list`, {
//           headers: { Authorization: `Bearer ${token}` },
//         }),
//         fetch(`${API_URL}/expence-bank-account-list`, {
//           headers: { Authorization: `Bearer ${token}` },
//         }),
//       ]);

//       const categoriesData = await categoriesResponse.json();
//       const bankAccountsData = await bankAccountsResponse.json();

//       if (categoriesData.status) {
//         setCategories(categoriesData.data);
//       }
//       if (bankAccountsData.status) {
//         setBankAccounts(bankAccountsData.data);
//       }
//     } catch (error) {
//       console.error("Failed to fetch dropdown data:", error);
//     }
//   };

//   useEffect(() => {
//     fetchExpenses(currentPage);
//     fetchDropdownData();
//     fetchProjects(); // Projects fetch करें
//   }, []);

//   const handlePageChange = (pageNumber) => {
//     if (pageNumber >= 1 && pageNumber <= totalPages) {
//       fetchExpenses(pageNumber);
//     }
//   };

//   // Edit modal show होने पर
//   const handleEditModalShow = (expense) => {
//     setEditFormData({
//       id: expense.id,
//       category_id: expense.category_id,
//       category_name: expense.category_name,
//       account_id: expense.account_id,
//       account_name: expense.account_name,
//       type: expense.type,
//       name: expense.name,
//       amount: expense.amount,
//       date: expense.date,
//       description: expense.description,
//       project_id: expense.project_id || "",
//       project_name: expense.project_name || "",
//       plot_id: expense.plot_id || "",
//       plot_name: expense.plot_name || "",
//     });

//     // Agar project_id hai to uske plots fetch करें
//     if (expense.project_id) {
//       fetchPlotsByProject(expense.project_id);
//     } else {
//       setFilteredPlots([]);
//     }

//     setEditModalShow(true);
//   };

//   const handleEditModalClose = () => {
//     setEditModalShow(false);
//     setFilteredPlots([]); // Reset plots
//   };

//   const handleEditFormChange = (e) => {
//     const { name, value } = e.target;
//     setEditFormData((prevData) => {
//       const newData = { ...prevData, [name]: value };

//       if (name === "category_id") {
//         const selectedCategory = categories.find(
//           (cat) => cat.id.toString() === value,
//         );
//         newData.category_name = selectedCategory ? selectedCategory.name : "";
//       }
//       if (name === "account_id") {
//         const selectedAccount = bankAccounts.find(
//           (acc) => acc.id.toString() === value,
//         );
//         newData.payee = selectedAccount ? selectedAccount.payee : "";
//       }
//       // Project change होने पर
//       if (name === "project_id") {
//         const selectedProject = projects.find(
//           (project) => project.id.toString() === value,
//         );
//         newData.project_name = selectedProject ? selectedProject.name : "";
//         newData.plot_id = ""; // Reset plot when project changes
//         newData.plot_name = "";

//         // Fetch plots for selected project
//         if (value) {
//           fetchPlotsByProject(value);
//         } else {
//           setFilteredPlots([]);
//         }
//       }
//       // Plot change होने पर
//       if (name === "plot_id") {
//         const selectedPlot = filteredPlots.find(
//           (plot) => plot.id.toString() === value,
//         );
//         newData.plot_name = selectedPlot
//           ? selectedPlot.name || selectedPlot.plot_number
//           : "";
//       }

//       return newData;
//     });
//   };

//   const handleEditSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);
//     const token = getAuthToken();

//     // Selected project और plot की details fetch करें
//     const selectedProject = projects.find(
//       (p) => p.id == editFormData.project_id,
//     );
//     const selectedPlot = filteredPlots.find(
//       (p) => p.id == editFormData.plot_id,
//     );

//     const payload = {
//       ...editFormData,
//       amount: parseFloat(editFormData.amount),
//       project_name: selectedProject ? selectedProject.name : "",
//       plot_name: selectedPlot
//         ? selectedPlot.name || selectedPlot.plot_number
//         : "",
//     };

//     try {
//       const response = await fetch(`${API_URL}/expence-update`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${token}`,
//         },
//         body: JSON.stringify(payload),
//       });

//       if (!response.ok) {
//         const errorData = await response.json();
//         throw new Error(errorData.message || "Failed to update expense.");
//       }

//       const result = await response.json();

//       if (result.success == "1") {
//         showCustomMessageModal("Success", result.message, "success");
//         handleEditModalClose();
//         fetchExpenses(currentPage);
//       } else {
//         throw new Error(result.message || "Failed to update Expenses.");
//       }
//     } catch (error) {
//       console.error("Error updating expense:", error);
//       showCustomMessageModal(
//         "Error",
//         error.message || "An unexpected error occurred.",
//         "error",
//       );
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleDeleteModalShow = (expenseId) => {
//     setExpenseToDelete(expenseId);
//     setDeleteModalShow(true);
//   };

//   const handleDeleteModalClose = () => {
//     setDeleteModalShow(false);
//     setExpenseToDelete(null);
//   };

//   const handleConfirmDelete = async () => {
//     setLoading(true);
//     const token = getAuthToken();

//     try {
//       const response = await fetch(`${API_URL}/expence-delete`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${token}`,
//         },
//         body: JSON.stringify({ id: expenseToDelete }),
//       });

//       if (!response.ok) {
//         const errorData = await response.json();
//         throw new Error(errorData.message || "Failed to delete expense.");
//       }

//       const result = await response.json();
//       showCustomMessageModal("Success", result.message, "success");

//       handleDeleteModalClose();
//       fetchExpenses(currentPage);
//     } catch (error) {
//       console.error("Error deleting expense:", error);
//       showCustomMessageModal(
//         "Error",
//         error.message || "An unexpected error occurred.",
//         "error",
//       );
//     } finally {
//       setLoading(false);
//     }
//   };

//   const [isFilterActive, setIsFilterActive] = useState(false);
//   const handleToggle = () => {
//     setIsFilterActive(!isFilterActive);
//   };

//   // return (
//   //   <>
//   //     <div className="card mt-2">
//   //       <div className="card-header expenselistdesign">
//   //         <div className="d-flex  justify-content-between align-items-center w-100">
//   //           <div className="titlepage expenselist">
//   //             <h3 className="mb-0">Expenses List</h3>
//   //           </div>

//   //           <div className="d-flex gap-2">
//   //             <button
//   //               className="exportingall"
//   //               onClick={exportAllToExcel}
//   //               disabled={exporting}
//   //             >
//   //               {exporting ? (
//   //                 <>
//   //                   <span
//   //                     className="spinner-border spinner-border-sm me-2"
//   //                     role="status"
//   //                     aria-hidden="true"
//   //                   ></span>
//   //                   Exporting All...
//   //                 </>
//   //               ) : (
//   //                 <FaDownload />
//   //               )}
//   //             </button>
//   //             <div className="d-flex gap-2">
//   //               <button
//   //                 className={`filter-toggle-btn btn ${isFilterActive ? "active" : ""}`}
//   //                 onClick={handleToggle}
//   //               >
//   //                 {isFilterActive ? (
//   //                   <>
//   //                     <MdFilterAltOff />
//   //                   </>
//   //                 ) : (
//   //                   <>
//   //                     <MdFilterAlt />
//   //                   </>
//   //                 )}
//   //               </button>
//   //             </div>
//   //           </div>
//   //         </div>
//   //       </div>

//   //       {isFilterActive && (
//   //         <div className="card-body pb-0">
//   //           <div className="d-flex gap-2 flex-wrap-mobile expencelistwrap">
//   //             <div className="form_design w-100">
//   //               <input
//   //                 type="text"
//   //                 name="name"
//   //                 placeholder="Name"
//   //                 value={searchTerm.name}
//   //                 onChange={(e) =>
//   //                   setSearchTerm({
//   //                     ...searchTerm,
//   //                     [e.target.name]: e.target.value,
//   //                   })
//   //                 }
//   //               />
//   //             </div>

//   //             <div className="form_design w-100">
//   //               <input
//   //                 type="text"
//   //                 name="payee"
//   //                 placeholder="Payee"
//   //                 value={searchTerm.payee}
//   //                 onChange={(e) =>
//   //                   setSearchTerm({
//   //                     ...searchTerm,
//   //                     [e.target.name]: e.target.value,
//   //                   })
//   //                 }
//   //               />
//   //             </div>

//   //             <div className="form_design w-100">
//   //               <select
//   //                 name="category"
//   //                 className=""
//   //                 value={searchTerm.category}
//   //                 onChange={(e) =>
//   //                   setSearchTerm({
//   //                     ...searchTerm,
//   //                     [e.target.name]: e.target.value,
//   //                   })
//   //                 }
//   //               >
//   //                 <option value="">Category</option>
//   //                 {categories.map((category) => (
//   //                   <option key={category.id} value={category.name}>
//   //                     {category.name}
//   //                   </option>
//   //                 ))}
//   //               </select>
//   //             </div>

//   //             <div className="form_design w-100">
//   //               <select
//   //                 name="type"
//   //                 className=""
//   //                 value={searchTerm.type}
//   //                 onChange={(e) =>
//   //                   setSearchTerm({
//   //                     ...searchTerm,
//   //                     [e.target.name]: e.target.value,
//   //                   })
//   //                 }
//   //               >
//   //                 <option value="">Type</option>
//   //                 <option value="online">Online</option>
//   //                 <option value="cash">Cash</option>
//   //               </select>
//   //             </div>

//   //             <div className="form_design w-100">
//   //               <input
//   //                 type="date"
//   //                 name="fromdate"
//   //                 placeholder="From Date"
//   //                 value={searchTerm.fromdate}
//   //                 onChange={(e) =>
//   //                   setSearchTerm({
//   //                     ...searchTerm,
//   //                     [e.target.name]: e.target.value,
//   //                   })
//   //                 }
//   //                 className="form-control"
//   //               />
//   //             </div>

//   //             <div className="form_design w-100">
//   //               <input
//   //                 type="date"
//   //                 name="todate"
//   //                 placeholder="To Date"
//   //                 value={searchTerm.todate}
//   //                 onChange={(e) =>
//   //                   setSearchTerm({
//   //                     ...searchTerm,
//   //                     [e.target.name]: e.target.value,
//   //                   })
//   //                 }
//   //                 className="form-control"
//   //               />
//   //             </div>

//   //             <button
//   //               type="button"
//   //               className="submit_button"
//   //               onClick={handleSearch}
//   //             >
//   //               Search
//   //             </button>
//   //           </div>
//   //         </div>
//   //       )}

//   //       <div className="card-body">
//   //         <Row>
//   //           <Col>
//   //             {dataLoading ? (
//   //               <div className="text-center p-5">
//   //                 <Spinner animation="border" />
//   //                 <p className="mt-2">Loading expenses...</p>
//   //               </div>
//   //             ) : (
//   //               <>
//   //                 <Table
//   //                   striped
//   //                   bordered
//   //                   hover
//   //                   responsive
//   //                   className="shadow-sm"
//   //                 >
//   //                   <thead>
//   //                     <tr>
//   //                       <th>ID</th>
//   //                       <th>Category Name</th>
//   //                       <th>Category Type</th>
//   //                       <th>Payee Name</th>
//   //                       <th>Type</th>
//   //                       <th>Expense Date</th>
//   //                       <th>Pay Date</th>
//   //                       <th>Project Name</th>
//   //                       <th>Unit Number</th>
//   //                       <th>Descriptions</th>
//   //                       <th>CR Amount</th>
//   //                       <th>DR Amount</th>
//   //                       <th>Balance</th>
//   //                       <th>Actions</th>
//   //                     </tr>
//   //                   </thead>
//   //                   <tbody>
//   //                     {expenses.length > 0 ? (
//   //                       expenses.map((expense, index) => (
//   //                         <tr key={expense.id}>
//   //                           <td>{(currentPage - 1) * limit + (index + 1)}</td>
//   //                           <td>{expense.category_name}</td>
//   //                           <td>{expense.category_type || "NA"}</td>
//   //                           <td>{formatText(expense.payee)}</td>

//   //                           <td>
//   //                             <span style={{ color: "blue" }}>
//   //                               {expense.type}
//   //                             </span>
//   //                           </td>
//   //                           <td>
//   //                             {(() => {
//   //                               const d = new Date(expense.date);
//   //                               const day = String(d.getDate()).padStart(
//   //                                 2,
//   //                                 "0",
//   //                               );
//   //                               const month = String(d.getMonth() + 1).padStart(
//   //                                 2,
//   //                                 "0",
//   //                               );
//   //                               const year = d.getFullYear();
//   //                               return `${day}-${month}-${year}`;
//   //                             })()}
//   //                           </td>
//   //                           <td>
//   //                             {(() => {
//   //                               const d = new Date(expense.created_at);
//   //                               const day = String(d.getDate()).padStart(
//   //                                 2,
//   //                                 "0",
//   //                               );
//   //                               const month = String(d.getMonth() + 1).padStart(
//   //                                 2,
//   //                                 "0",
//   //                               );
//   //                               const year = d.getFullYear();
//   //                               return `${day}-${month}-${year}`;
//   //                             })()}
//   //                           </td>
//   //                           <td>{expense.project_name || "NA"}</td>
//   //                           <td>{expense.plot_name || "NA"}</td>
//   //                           <td>
//   //                             <div className="table-cell-remark">
//   //                               {expense.description
//   //                                 ? expense.description
//   //                                     .charAt(0)
//   //                                     .toUpperCase() +
//   //                                   expense.description.slice(1).toLowerCase()
//   //                                 : "NA"}
//   //                             </div>
//   //                           </td>
//   //                           <td>
//   //                             {/* CR Amount Column */}
//   //                             {expense.category_type === "cr" ? (
//   //                               <span
//   //                                 style={{ color: "green", fontWeight: "bold" }}
//   //                               >
//   //                                 ₹ {expense.amount}
//   //                               </span>
//   //                             ) : (
//   //                               <span style={{ color: "#ccc" }}>₹ 0</span>
//   //                             )}
//   //                           </td>
//   //                           <td>
//   //                             {/* DR Amount Column */}
//   //                             {expense.category_type === "dr" ? (
//   //                               <span
//   //                                 style={{ color: "red", fontWeight: "bold" }}
//   //                               >
//   //                                 ₹ {expense.amount}
//   //                               </span>
//   //                             ) : (
//   //                               <span style={{ color: "#ccc" }}>₹ 0</span>
//   //                             )}
//   //                           </td>
//   //                           <td>
//   //                             {/* Balance Column */}
//   //                             <span
//   //                               style={{
//   //                                 color:
//   //                                   expense.running_balance >= 0
//   //                                     ? "green"
//   //                                     : "red",
//   //                                 fontWeight: "bold",
//   //                               }}
//   //                             >
//   //                               ₹{" "}
//   //                               {expense.running_balance?.toLocaleString() || 0}
//   //                             </span>
//   //                           </td>
//   //                           <td>
//   //                             <div className="dropdown">
//   //                               <button
//   //                                 className="btn light btn-action dropdown-toggle"
//   //                                 type="button"
//   //                                 id="dropdownMenuButton"
//   //                                 data-bs-toggle="dropdown"
//   //                                 aria-expanded="false"
//   //                               >
//   //                                 <BsThreeDots size={20} />
//   //                               </button>

//   //                               <ul
//   //                                 className="dropdown-menu"
//   //                                 aria-labelledby="dropdownMenuButton"
//   //                               >
//   //                                 <li className="dropdown-item">
//   //                                   <button
//   //                                     className="btn edit_btn btn-sm me-1"
//   //                                     onClick={() =>
//   //                                       handleEditModalShow(expense)
//   //                                     }
//   //                                     title="Edit Project"
//   //                                   >
//   //                                     <FaEdit /> Edit
//   //                                   </button>
//   //                                 </li>

//   //                                 <li className="dropdown-item">
//   //                                   <button
//   //                                     className="btn delete_btn btn-sm"
//   //                                     onClick={() =>
//   //                                       handleDeleteModalShow(expense.id)
//   //                                     }
//   //                                     title="Delete Project"
//   //                                   >
//   //                                     <RiDeleteBin3Fill /> Delete
//   //                                   </button>
//   //                                 </li>
//   //                               </ul>
//   //                             </div>
//   //                           </td>
//   //                         </tr>
//   //                       ))
//   //                     ) : (
//   //                       <tr>
//   //                         <td colSpan="14" className="text-center">
//   //                           No expenses found.
//   //                         </td>
//   //                       </tr>
//   //                     )}
//   //                   </tbody>
//   //                 </Table>

//   //                 {/* Totals Summary Row (Optional) */}
//   //                 {/* {expenses.length > 0 && (
//   //                   <div className="mt-3 p-3 bg-light border rounded">
//   //                       <div className="row">
//   //                           <div className="col-md-4">
//   //                               <strong>Total CR:</strong> ₹ {summary?.total_cr?.toLocaleString() || 0}
//   //                           </div>
//   //                           <div className="col-md-4">
//   //                               <strong>Total DR:</strong> ₹ {summary?.total_dr?.toLocaleString() || 0}
//   //                           </div>
//   //                           <div className="col-md-4">
//   //                               <strong>Net Balance:</strong> ₹ {summary?.net_balance?.toLocaleString() || 0}
//   //                           </div>
//   //                       </div>
//   //                   </div>
//   //               )} */}

//   //                 <div className="d-flex justify-content-end mt-3">
//   //                   <Pagination>
//   //                     <Pagination.Prev
//   //                       onClick={() => handlePageChange(currentPage - 1)}
//   //                       disabled={currentPage === 1}
//   //                     />

//   //                     {/* Always show first page */}
//   //                     <Pagination.Item
//   //                       active={1 === currentPage}
//   //                       onClick={() => handlePageChange(1)}
//   //                     >
//   //                       1
//   //                     </Pagination.Item>

//   //                     {/* Show ellipsis if there are pages before current page beyond page 2 */}
//   //                     {currentPage > 3 && <Pagination.Ellipsis />}

//   //                     {/* Show pages around current page */}
//   //                     {[...Array(totalPages)].map((_, index) => {
//   //                       const pageNumber = index + 1;
//   //                       // Show page if it's within 1 of current page (except page 1 which is always shown)
//   //                       if (
//   //                         pageNumber > 1 &&
//   //                         pageNumber < totalPages &&
//   //                         Math.abs(pageNumber - currentPage) <= 1
//   //                       ) {
//   //                         return (
//   //                           <Pagination.Item
//   //                             key={pageNumber}
//   //                             active={pageNumber === currentPage}
//   //                             onClick={() => handlePageChange(pageNumber)}
//   //                           >
//   //                             {pageNumber}
//   //                           </Pagination.Item>
//   //                         );
//   //                       }
//   //                       return null;
//   //                     })}

//   //                     {/* Show ellipsis if there are pages after current page before last page */}
//   //                     {currentPage < totalPages - 2 && <Pagination.Ellipsis />}

//   //                     {/* Always show last page if there's more than 1 page */}
//   //                     {totalPages > 1 && (
//   //                       <Pagination.Item
//   //                         active={totalPages === currentPage}
//   //                         onClick={() => handlePageChange(totalPages)}
//   //                       >
//   //                         {totalPages}
//   //                       </Pagination.Item>
//   //                     )}

//   //                     <Pagination.Next
//   //                       onClick={() => handlePageChange(currentPage + 1)}
//   //                       disabled={currentPage === totalPages}
//   //                     />
//   //                   </Pagination>
//   //                 </div>
//   //               </>
//   //             )}
//   //           </Col>
//   //         </Row>
//   //       </div>
//   //     </div>

//   //     {/* Edit Expense Modal - Project और Plot fields जोड़ें */}
//   //     <Modal
//   //       show={editModalShow}
//   //       onHide={handleEditModalClose}
//   //       centered
//   //       size="lg"
//   //     >
//   //       <Modal.Header closeButton>
//   //         <Modal.Title>Edit Expense</Modal.Title>
//   //       </Modal.Header>
//   //       <Form onSubmit={handleEditSubmit}>
//   //         <Modal.Body>
//   //           <Row>
//   //             <Col md={6}>
//   //               <Form.Group className="mb-3">
//   //                 <Form.Label>Category</Form.Label>
//   //                 <Form.Control
//   //                   as="select"
//   //                   name="category_id"
//   //                   value={editFormData.category_id}
//   //                   onChange={handleEditFormChange}
//   //                   required
//   //                 >
//   //                   <option value="">Select Category</option>
//   //                   {categories?.map((cat) => (
//   //                     <option key={cat.id} value={cat.id}>
//   //                       {cat.name}
//   //                     </option>
//   //                   ))}
//   //                 </Form.Control>
//   //               </Form.Group>
//   //             </Col>
//   //             <Col md={6}>
//   //               <Form.Group className="mb-3">
//   //                 <Form.Label>Select Name</Form.Label>
//   //                 <Form.Control
//   //                   as="select"
//   //                   name="account_id"
//   //                   value={editFormData.account_id}
//   //                   onChange={handleEditFormChange}
//   //                   required
//   //                 >
//   //                   <option value="">Select Name</option>
//   //                   {bankAccounts?.map((acc) => (
//   //                     <option key={acc.id} value={acc.id}>
//   //                       {acc.name} ({acc.payee})
//   //                     </option>
//   //                   ))}
//   //                 </Form.Control>
//   //               </Form.Group>
//   //             </Col>

//   //             {/* Project Field */}
//   //             <Col md={6}>
//   //               <Form.Group className="mb-3">
//   //                 <Form.Label>Project Name</Form.Label>
//   //                 <Form.Control
//   //                   as="select"
//   //                   name="project_id"
//   //                   value={editFormData.project_id}
//   //                   onChange={handleEditFormChange}
//   //                 >
//   //                   <option value="">Select Project</option>
//   //                   {projects?.map((project) => (
//   //                     <option key={project.id} value={project.id}>
//   //                       {project.name}
//   //                     </option>
//   //                   ))}
//   //                 </Form.Control>
//   //               </Form.Group>
//   //             </Col>

//   //             {/* Plot Field - Project select होने पर ही enabled हो */}
//   //             <Col md={6}>
//   //               <Form.Group className="mb-3">
//   //                 <Form.Label>Unit Number</Form.Label>
//   //                 <Form.Control
//   //                   as="select"
//   //                   name="plot_id"
//   //                   value={editFormData.plot_id}
//   //                   onChange={handleEditFormChange}
//   //                   disabled={!editFormData.project_id}
//   //                 >
//   //                   <option value="">Select Plot</option>
//   //                   {filteredPlots?.map((plot) => (
//   //                     <option key={plot.id} value={plot.id}>
//   //                       {plot.plot_shop_villa_no ||
//   //                         plot.plot_shop_villa_no ||
//   //                         `Plot ${plot.id}`}
//   //                     </option>
//   //                   ))}
//   //                 </Form.Control>
//   //               </Form.Group>
//   //             </Col>

//   //             <Col md={6}>
//   //               <Form.Group className="mb-3">
//   //                 <Form.Label>Receiver Name</Form.Label>
//   //                 <Form.Control
//   //                   type="text"
//   //                   name="name"
//   //                   value={editFormData.name}
//   //                   onChange={handleEditFormChange}
//   //                   required
//   //                 />
//   //               </Form.Group>
//   //             </Col>
//   //             <Col md={6}>
//   //               <Form.Group className="mb-3">
//   //                 <Form.Label>Amount</Form.Label>
//   //                 <Form.Control
//   //                   type="number"
//   //                   name="amount"
//   //                   value={editFormData.amount}
//   //                   onChange={handleEditFormChange}
//   //                   required
//   //                 />
//   //               </Form.Group>
//   //             </Col>
//   //             <Col md={6}>
//   //               <Form.Group className="mb-3">
//   //                 <Form.Label>Type</Form.Label>
//   //                 <Form.Control
//   //                   type="text"
//   //                   name="type"
//   //                   value={editFormData.type}
//   //                   onChange={handleEditFormChange}
//   //                   readOnly
//   //                 />
//   //               </Form.Group>
//   //             </Col>
//   //             <Col md={6}>
//   //               <Form.Group className="mb-3">
//   //                 <Form.Label>Date</Form.Label>
//   //                 <Form.Control
//   //                   type="date"
//   //                   name="date"
//   //                   value={editFormData.date}
//   //                   onChange={handleEditFormChange}
//   //                   required
//   //                 />
//   //               </Form.Group>
//   //             </Col>
//   //             <Col md={12}>
//   //               <Form.Group className="mb-3">
//   //                 <Form.Label>Description</Form.Label>
//   //                 <Form.Control
//   //                   as="textarea"
//   //                   name="description"
//   //                   rows={3}
//   //                   value={editFormData.description}
//   //                   onChange={handleEditFormChange}
//   //                 />
//   //               </Form.Group>
//   //             </Col>
//   //           </Row>
//   //         </Modal.Body>
//   //         <Modal.Footer>
//   //           <Button variant="danger" onClick={handleEditModalClose}>
//   //             Cancel
//   //           </Button>
//   //           <Button variant="primary" type="submit" disabled={loading}>
//   //             {loading ? (
//   //               <Spinner animation="border" size="sm" />
//   //             ) : (
//   //               "Save Changes"
//   //             )}
//   //           </Button>
//   //         </Modal.Footer>
//   //       </Form>
//   //     </Modal>

//   //     {/* Delete Confirmation Modal */}
//   //     <Modal show={deleteModalShow} onHide={handleDeleteModalClose} centered>
//   //       <Modal.Header closeButton>
//   //         <Modal.Title>Confirm Deletion</Modal.Title>
//   //       </Modal.Header>
//   //       <Modal.Body>
//   //         Are you sure you want to delete this expense? This action cannot be
//   //         undone.
//   //       </Modal.Body>
//   //       <Modal.Footer>
//   //         <Button variant="secondary" onClick={handleDeleteModalClose}>
//   //           Cancel
//   //         </Button>
//   //         <Button
//   //           variant="danger"
//   //           onClick={handleConfirmDelete}
//   //           disabled={loading}
//   //         >
//   //           {loading ? <Spinner animation="border" size="sm" /> : "Delete"}
//   //         </Button>
//   //       </Modal.Footer>
//   //     </Modal>

//   //     {/* Message Modal */}
//   //     <Modal show={showMessageModal} onHide={closeCustomMessageModal} centered>
//   //       <Modal.Header closeButton>
//   //         <Modal.Title
//   //           className={
//   //             messageModalContent.type === "success"
//   //               ? "text-success"
//   //               : "text-danger"
//   //           }
//   //         >
//   //           {messageModalContent.title}
//   //         </Modal.Title>
//   //       </Modal.Header>
//   //       <Modal.Body>{messageModalContent.text}</Modal.Body>
//   //       <Modal.Footer>
//   //         <Button variant="primary" onClick={closeCustomMessageModal}>
//   //           OK
//   //         </Button>
//   //       </Modal.Footer>
//   //     </Modal>
//   //   </>
//   // );
//   return (
//     <>
//       <div
//         style={{
//           minHeight: "100vh",
//           background: "linear-gradient(135deg, #f0f6ff 0%, #e6f0fa 100%)",
//           padding: "30px 24px",
//           fontFamily: "'Poppins', 'DM Sans', sans-serif",
//         }}
//       >
//         <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
//           {/* 🎯 HEADER CARD */}
//           <div
//             style={{
//               background: "#ffffff",
//               borderRadius: "16px",
//               boxShadow: "0 8px 24px rgba(30, 87, 153, 0.08)",
//               border: "1.5px solid #e2e8f0",
//               padding: "20px 24px",
//               display: "flex",
//               alignItems: "center",
//               gap: "16px",
//               marginBottom: "20px",
//               flexWrap: "wrap",
//             }}
//           >
//             <div
//               style={{
//                 width: "52px",
//                 height: "52px",
//                 borderRadius: "14px",
//                 background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 color: "#ffffff",
//                 fontSize: "24px",
//                 boxShadow: "0 8px 20px rgba(30, 87, 153, 0.3)",
//                 flexShrink: 0,
//               }}
//             >
//               📋
//             </div>
//             <div style={{ flex: 1, minWidth: "200px" }}>
//               <h1
//                 style={{
//                   margin: 0,
//                   fontSize: "24px",
//                   fontWeight: "800",
//                   color: "#1e3a5f",
//                   letterSpacing: "-0.5px",
//                 }}
//               >
//                 Expenses List
//               </h1>
//               <p
//                 style={{
//                   margin: "2px 0 0",
//                   fontSize: "13px",
//                   color: "#64748b",
//                   fontWeight: "500",
//                 }}
//               >
//                 View, filter and export all your expenses
//               </p>
//             </div>

//             <div className="d-flex gap-2 flex-wrap">
//               <button
//                 className="exportingall btn btn-success d-flex align-items-center gap-2"
//                 onClick={exportAllToExcel}
//                 disabled={exporting}
//               >
//                 {exporting ? (
//                   <>
//                     <span
//                       className="spinner-border spinner-border-sm me-2"
//                       role="status"
//                       aria-hidden="true"
//                     ></span>
//                     Exporting...
//                   </>
//                 ) : (
//                   <>
//                     <FaDownload /> Export
//                   </>
//                 )}
//               </button>

//               <button
//                 className={`filter-toggle-btn btn ${isFilterActive ? "active" : ""}`}
//                 onClick={handleToggle}
//                 style={{
//                   width: "44px",
//                   height: "44px",
//                   borderRadius: "12px",
//                   border: "1.5px solid #e2e8f0",
//                   background: isFilterActive ? "#1e5799" : "#ffffff",
//                   color: isFilterActive ? "#ffffff" : "#1e3a5f",
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "center",
//                   fontSize: "20px",
//                   cursor: "pointer",
//                   transition: "all 0.25s ease",
//                   boxShadow: isFilterActive
//                     ? "0 8px 20px rgba(30, 87, 153, 0.3)"
//                     : "none",
//                 }}
//                 title={isFilterActive ? "Hide Filters" : "Show Filters"}
//               >
//                 {isFilterActive ? <MdFilterAltOff /> : <MdFilterAlt />}
//               </button>
//             </div>
//           </div>

//           {/* 🎯 MAIN CARD */}
//           <div
//             style={{
//               background: "#ffffff",
//               borderRadius: "16px",
//               boxShadow: "0 8px 24px rgba(30, 87, 153, 0.08)",
//               border: "1.5px solid #e2e8f0",
//               overflow: "hidden",
//             }}
//           >
//             <div
//               style={{
//                 height: "5px",
//                 background: "linear-gradient(90deg, #1e5799, #2b6cb0, #1e5799)",
//               }}
//             />

//             <div style={{ padding: "30px" }}>
//               {/* FILTER PANEL */}
//               {isFilterActive && (
//                 <div
//                   style={{
//                     background: "#f8fafc",
//                     border: "1.5px dashed #cbd5e1",
//                     borderRadius: "12px",
//                     padding: "20px",
//                     marginBottom: "24px",
//                   }}
//                 >
//                   <Row className="gy-3">
//                     <Col md={6} lg={3}>
//                       <input
//                         type="text"
//                         name="name"
//                         placeholder="Name"
//                         className="form-control"
//                         value={searchTerm.name}
//                         onChange={(e) =>
//                           setSearchTerm({
//                             ...searchTerm,
//                             [e.target.name]: e.target.value,
//                           })
//                         }
//                       />
//                     </Col>

//                     <Col md={6} lg={3}>
//                       <input
//                         type="text"
//                         name="payee"
//                         placeholder="Payee"
//                         className="form-control"
//                         value={searchTerm.payee}
//                         onChange={(e) =>
//                           setSearchTerm({
//                             ...searchTerm,
//                             [e.target.name]: e.target.value,
//                           })
//                         }
//                       />
//                     </Col>

//                     <Col md={6} lg={3}>
//                       <select
//                         name="category"
//                         className="form-control"
//                         value={searchTerm.category}
//                         onChange={(e) =>
//                           setSearchTerm({
//                             ...searchTerm,
//                             [e.target.name]: e.target.value,
//                           })
//                         }
//                       >
//                         <option value="">Category</option>
//                         {categories.map((category) => (
//                           <option key={category.id} value={category.name}>
//                             {category.name}
//                           </option>
//                         ))}
//                       </select>
//                     </Col>

//                     <Col md={6} lg={3}>
//                       <select
//                         name="type"
//                         className="form-control"
//                         value={searchTerm.type}
//                         onChange={(e) =>
//                           setSearchTerm({
//                             ...searchTerm,
//                             [e.target.name]: e.target.value,
//                           })
//                         }
//                       >
//                         <option value="">Type</option>
//                         <option value="online">Online</option>
//                         <option value="cash">Cash</option>
//                       </select>
//                     </Col>

//                     <Col md={6} lg={3}>
//                       <input
//                         type="date"
//                         name="fromdate"
//                         value={searchTerm.fromdate}
//                         onChange={(e) =>
//                           setSearchTerm({
//                             ...searchTerm,
//                             [e.target.name]: e.target.value,
//                           })
//                         }
//                         className="form-control"
//                       />
//                     </Col>

//                     <Col md={6} lg={3}>
//                       <input
//                         type="date"
//                         name="todate"
//                         value={searchTerm.todate}
//                         onChange={(e) =>
//                           setSearchTerm({
//                             ...searchTerm,
//                             [e.target.name]: e.target.value,
//                           })
//                         }
//                         className="form-control"
//                       />
//                     </Col>

//                     <Col md={12} lg={12}>
//                       <div className="d-flex gap-2 justify-content-end">
//                         <button
//                           type="button"
//                           className="btn btn-primary"
//                           onClick={handleSearch}
//                         >
//                           Search
//                         </button>
//                       </div>
//                     </Col>
//                   </Row>
//                 </div>
//               )}

//               {/* TABLE */}
//               <Row>
//                 <Col>
//                   {dataLoading ? (
//                     <div className="text-center p-5">
//                       <Spinner animation="border" />
//                       <p className="mt-3">Loading expenses...</p>
//                     </div>
//                   ) : (
//                     <>
//                       <Table
//                         striped
//                         bordered
//                         hover
//                         responsive
//                         className="shadow-sm"
//                       >
//                         <thead>
//                           <tr>
//                             <th>ID</th>
//                             <th>Category Name</th>
//                             <th>Category Type</th>
//                             <th>Payee Name</th>
//                             <th>Type</th>
//                             <th>Expense Date</th>
//                             <th>Pay Date</th>
//                             <th>Project Name</th>
//                             <th>Unit Number</th>
//                             <th>Descriptions</th>
//                             <th>CR Amount</th>
//                             <th>DR Amount</th>
//                             <th>Balance</th>
//                             <th>Actions</th>
//                           </tr>
//                         </thead>
//                         <tbody>
//                           {expenses.length > 0 ? (
//                             expenses.map((expense, index) => (
//                               <tr key={expense.id}>
//                                 <td>
//                                   {(currentPage - 1) * limit + (index + 1)}
//                                 </td>
//                                 <td>{expense.category_name}</td>
//                                 <td>{expense.category_type || "NA"}</td>
//                                 <td>{formatText(expense.payee)}</td>

//                                 <td>
//                                   <span style={{ color: "blue" }}>
//                                     {expense.type}
//                                   </span>
//                                 </td>
//                                 <td>
//                                   {(() => {
//                                     const d = new Date(expense.date);
//                                     const day = String(d.getDate()).padStart(
//                                       2,
//                                       "0",
//                                     );
//                                     const month = String(
//                                       d.getMonth() + 1,
//                                     ).padStart(2, "0");
//                                     const year = d.getFullYear();
//                                     return `${day}-${month}-${year}`;
//                                   })()}
//                                 </td>
//                                 <td>
//                                   {(() => {
//                                     const d = new Date(expense.created_at);
//                                     const day = String(d.getDate()).padStart(
//                                       2,
//                                       "0",
//                                     );
//                                     const month = String(
//                                       d.getMonth() + 1,
//                                     ).padStart(2, "0");
//                                     const year = d.getFullYear();
//                                     return `${day}-${month}-${year}`;
//                                   })()}
//                                 </td>
//                                 <td>{expense.project_name || "NA"}</td>
//                                 <td>{expense.plot_name || "NA"}</td>
//                                 <td>
//                                   <div className="table-cell-remark">
//                                     {expense.description
//                                       ? expense.description
//                                           .charAt(0)
//                                           .toUpperCase() +
//                                         expense.description
//                                           .slice(1)
//                                           .toLowerCase()
//                                       : "NA"}
//                                   </div>
//                                 </td>
//                                 <td>
//                                   {expense.category_type === "cr" ? (
//                                     <span
//                                       style={{
//                                         color: "green",
//                                         fontWeight: "bold",
//                                       }}
//                                     >
//                                       ₹ {expense.amount}
//                                     </span>
//                                   ) : (
//                                     <span style={{ color: "#ccc" }}>₹ 0</span>
//                                   )}
//                                 </td>
//                                 <td>
//                                   {expense.category_type === "dr" ? (
//                                     <span
//                                       style={{
//                                         color: "red",
//                                         fontWeight: "bold",
//                                       }}
//                                     >
//                                       ₹ {expense.amount}
//                                     </span>
//                                   ) : (
//                                     <span style={{ color: "#ccc" }}>₹ 0</span>
//                                   )}
//                                 </td>
//                                 <td>
//                                   <span
//                                     style={{
//                                       color:
//                                         expense.running_balance >= 0
//                                           ? "green"
//                                           : "red",
//                                       fontWeight: "bold",
//                                     }}
//                                   >
//                                     ₹{" "}
//                                     {expense.running_balance?.toLocaleString() ||
//                                       0}
//                                   </span>
//                                 </td>
//                                 <td>
//                                   <div className="dropdown">
//                                     <button
//                                       className="btn light btn-action dropdown-toggle"
//                                       type="button"
//                                       id="dropdownMenuButton"
//                                       data-bs-toggle="dropdown"
//                                       aria-expanded="false"
//                                     >
//                                       <BsThreeDots size={20} />
//                                     </button>

//                                     <ul
//                                       className="dropdown-menu"
//                                       aria-labelledby="dropdownMenuButton"
//                                     >
//                                       <li className="dropdown-item">
//                                         <button
//                                           className="btn edit_btn btn-sm me-1"
//                                           onClick={() =>
//                                             handleEditModalShow(expense)
//                                           }
//                                           title="Edit Expense"
//                                         >
//                                           <FaEdit /> Edit
//                                         </button>
//                                       </li>

//                                       <li className="dropdown-item">
//                                         <button
//                                           className="btn delete_btn btn-sm"
//                                           onClick={() =>
//                                             handleDeleteModalShow(expense.id)
//                                           }
//                                           title="Delete Expense"
//                                         >
//                                           <RiDeleteBin3Fill /> Delete
//                                         </button>
//                                       </li>
//                                     </ul>
//                                   </div>
//                                 </td>
//                               </tr>
//                             ))
//                           ) : (
//                             <tr>
//                               <td colSpan="14" className="text-center">
//                                 No expenses found.
//                               </td>
//                             </tr>
//                           )}
//                         </tbody>
//                       </Table>

//                       {/* Pagination */}
//                       <div className="d-flex justify-content-end mt-3">
//                         <Pagination>
//                           <Pagination.Prev
//                             onClick={() =>
//                               handlePageChange(currentPage - 1)
//                             }
//                             disabled={currentPage === 1}
//                           />

//                           <Pagination.Item
//                             active={1 === currentPage}
//                             onClick={() => handlePageChange(1)}
//                           >
//                             1
//                           </Pagination.Item>

//                           {currentPage > 3 && <Pagination.Ellipsis />}

//                           {[...Array(totalPages)].map((_, index) => {
//                             const pageNumber = index + 1;
//                             if (
//                               pageNumber > 1 &&
//                               pageNumber < totalPages &&
//                               Math.abs(pageNumber - currentPage) <= 1
//                             ) {
//                               return (
//                                 <Pagination.Item
//                                   key={pageNumber}
//                                   active={pageNumber === currentPage}
//                                   onClick={() => handlePageChange(pageNumber)}
//                                 >
//                                   {pageNumber}
//                                 </Pagination.Item>
//                               );
//                             }
//                             return null;
//                           })}

//                           {currentPage < totalPages - 2 && (
//                             <Pagination.Ellipsis />
//                           )}

//                           {totalPages > 1 && (
//                             <Pagination.Item
//                               active={totalPages === currentPage}
//                               onClick={() => handlePageChange(totalPages)}
//                             >
//                               {totalPages}
//                             </Pagination.Item>
//                           )}

//                           <Pagination.Next
//                             onClick={() =>
//                               handlePageChange(currentPage + 1)
//                             }
//                             disabled={currentPage === totalPages}
//                           />
//                         </Pagination>
//                       </div>
//                     </>
//                   )}
//                 </Col>
//               </Row>
//             </div>
//           </div>

//           {/* Footer Copyright */}
//           <p
//             style={{
//               textAlign: "center",
//               color: "#94a3b8",
//               fontSize: "12.5px",
//               marginTop: "24px",
//               fontWeight: "500",
//             }}
//           >
//             © {new Date().getFullYear()} A2 Demo Real Estates Pvt Ltd. All
//             Rights Reserved.
//           </p>
//         </div>
//       </div>

//       {/* 🎯 EDIT EXPENSE MODAL */}
//       <Modal
//         show={editModalShow}
//         onHide={handleEditModalClose}
//         centered
//         size="lg"
//       >
//         <Modal.Header closeButton>
//           <Modal.Title>Edit Expense</Modal.Title>
//         </Modal.Header>
//         <Form onSubmit={handleEditSubmit}>
//           <Modal.Body>
//             <Row>
//               <Col md={6}>
//                 <Form.Group className="mb-3">
//                   <Form.Label>Category</Form.Label>
//                   <Form.Control
//                     as="select"
//                     name="category_id"
//                     value={editFormData.category_id}
//                     onChange={handleEditFormChange}
//                     required
//                   >
//                     <option value="">Select Category</option>
//                     {categories?.map((cat) => (
//                       <option key={cat.id} value={cat.id}>
//                         {cat.name}
//                       </option>
//                     ))}
//                   </Form.Control>
//                 </Form.Group>
//               </Col>
//               <Col md={6}>
//                 <Form.Group className="mb-3">
//                   <Form.Label>Select Name</Form.Label>
//                   <Form.Control
//                     as="select"
//                     name="account_id"
//                     value={editFormData.account_id}
//                     onChange={handleEditFormChange}
//                     required
//                   >
//                     <option value="">Select Name</option>
//                     {bankAccounts?.map((acc) => (
//                       <option key={acc.id} value={acc.id}>
//                         {acc.name} ({acc.payee})
//                       </option>
//                     ))}
//                   </Form.Control>
//                 </Form.Group>
//               </Col>

//               <Col md={6}>
//                 <Form.Group className="mb-3">
//                   <Form.Label>Project Name</Form.Label>
//                   <Form.Control
//                     as="select"
//                     name="project_id"
//                     value={editFormData.project_id}
//                     onChange={handleEditFormChange}
//                   >
//                     <option value="">Select Project</option>
//                     {projects?.map((project) => (
//                       <option key={project.id} value={project.id}>
//                         {project.name}
//                       </option>
//                     ))}
//                   </Form.Control>
//                 </Form.Group>
//               </Col>

//               <Col md={6}>
//                 <Form.Group className="mb-3">
//                   <Form.Label>Unit Number</Form.Label>
//                   <Form.Control
//                     as="select"
//                     name="plot_id"
//                     value={editFormData.plot_id}
//                     onChange={handleEditFormChange}
//                     disabled={!editFormData.project_id}
//                   >
//                     <option value="">Select Plot</option>
//                     {filteredPlots?.map((plot) => (
//                       <option key={plot.id} value={plot.id}>
//                         {plot.plot_shop_villa_no ||
//                           plot.plot_shop_villa_no ||
//                           `Plot ${plot.id}`}
//                       </option>
//                     ))}
//                   </Form.Control>
//                 </Form.Group>
//               </Col>

//               <Col md={6}>
//                 <Form.Group className="mb-3">
//                   <Form.Label>Receiver Name</Form.Label>
//                   <Form.Control
//                     type="text"
//                     name="name"
//                     value={editFormData.name}
//                     onChange={handleEditFormChange}
//                     required
//                   />
//                 </Form.Group>
//               </Col>
//               <Col md={6}>
//                 <Form.Group className="mb-3">
//                   <Form.Label>Amount</Form.Label>
//                   <Form.Control
//                     type="number"
//                     name="amount"
//                     value={editFormData.amount}
//                     onChange={handleEditFormChange}
//                     required
//                   />
//                 </Form.Group>
//               </Col>
//               <Col md={6}>
//                 <Form.Group className="mb-3">
//                   <Form.Label>Type</Form.Label>
//                   <Form.Control
//                     type="text"
//                     name="type"
//                     value={editFormData.type}
//                     onChange={handleEditFormChange}
//                     readOnly
//                   />
//                 </Form.Group>
//               </Col>
//               <Col md={6}>
//                 <Form.Group className="mb-3">
//                   <Form.Label>Date</Form.Label>
//                   <Form.Control
//                     type="date"
//                     name="date"
//                     value={editFormData.date}
//                     onChange={handleEditFormChange}
//                     required
//                   />
//                 </Form.Group>
//               </Col>
//               <Col md={12}>
//                 <Form.Group className="mb-3">
//                   <Form.Label>Description</Form.Label>
//                   <Form.Control
//                     as="textarea"
//                     name="description"
//                     rows={3}
//                     value={editFormData.description}
//                     onChange={handleEditFormChange}
//                   />
//                 </Form.Group>
//               </Col>
//             </Row>
//           </Modal.Body>
//           <Modal.Footer>
//             <Button variant="danger" onClick={handleEditModalClose}>
//               Cancel
//             </Button>
//             <Button variant="primary" type="submit" disabled={loading}>
//               {loading ? (
//                 <Spinner animation="border" size="sm" />
//               ) : (
//                 "Save Changes"
//               )}
//             </Button>
//           </Modal.Footer>
//         </Form>
//       </Modal>

//       {/* 🎯 DELETE CONFIRM MODAL */}
//       <Modal show={deleteModalShow} onHide={handleDeleteModalClose} centered>
//         <Modal.Header closeButton>
//           <Modal.Title>Confirm Deletion</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           Are you sure you want to delete this expense? This action cannot be
//           undone.
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={handleDeleteModalClose}>
//             Cancel
//           </Button>
//           <Button
//             variant="danger"
//             onClick={handleConfirmDelete}
//             disabled={loading}
//           >
//             {loading ? <Spinner animation="border" size="sm" /> : "Delete"}
//           </Button>
//         </Modal.Footer>
//       </Modal>

//       {/* 🎯 MESSAGE MODAL */}
//       <Modal show={showMessageModal} onHide={closeCustomMessageModal} centered>
//         <Modal.Header closeButton>
//           <Modal.Title
//             className={
//               messageModalContent.type === "success"
//                 ? "text-success"
//                 : "text-danger"
//             }
//           >
//             {messageModalContent.title}
//           </Modal.Title>
//         </Modal.Header>
//         <Modal.Body>{messageModalContent.text}</Modal.Body>
//         <Modal.Footer>
//           <Button variant="primary" onClick={closeCustomMessageModal}>
//             OK
//           </Button>
//         </Modal.Footer>
//       </Modal>
//     </>
//   );
  
// }

// export default ExpensesList;
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FaPlus, FaEdit, FaDownload } from "react-icons/fa";
import { Modal, Button, Form, Table, Pagination, Row, Col, Spinner } from "react-bootstrap";
import { RiDeleteBin3Fill } from "react-icons/ri";
import { BsThreeDots } from "react-icons/bs";
import { MdFilterAlt, MdFilterAltOff } from "react-icons/md";
import * as XLSX from "xlsx";

const API_URL = process.env.REACT_APP_API_URL;

// ─── Shared modal / input styles ───
const labelStyle = {
  display: "block",
  fontSize: "12.5px",
  fontWeight: "700",
  color: "#1e3a5f",
  marginBottom: "6px",
  letterSpacing: "0.2px",
};

const inputStyle = {
  width: "100%",
  padding: "10px 14px",
  borderRadius: "10px",
  border: "1.5px solid #e2e8f0",
  fontSize: "13.5px",
  fontWeight: "500",
  color: "#1e3a5f",
  outline: "none",
  boxSizing: "border-box",
  transition: "all 0.2s ease",
  background: "#ffffff",
};

const dropdownItem = {
  padding: "9px 12px",
  borderRadius: "10px",
  fontSize: "13px",
  fontWeight: "600",
  gap: "10px",
  transition: "all 0.18s ease",
  marginBottom: "2px",
  border: "none",
  background: "transparent",
  width: "100%",
  textAlign: "left",
  color: "#1e5799",
  display: "flex",
  alignItems: "center",
};

const iconBadge = (bg, color) => ({
  width: "28px",
  height: "28px",
  borderRadius: "8px",
  background: bg,
  color: color,
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
});

function ExpensesList() {
  const navigate = useNavigate();
  const [expenses, setExpenses] = useState([]);
  const [loading, setLoading] = useState(false);
  const [dataLoading, setDataLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [exporting, setExporting] = useState(false);
  const [limit] = useState(10);
  const [isFilterActive, setIsFilterActive] = useState(false);

  const [editModalShow, setEditModalShow] = useState(false);
  const [editFormData, setEditFormData] = useState({
    id: "",
    category_id: "",
    category_name: "",
    account_id: "",
    payee: "",
    type: "",
    name: "",
    amount: "",
    date: "",
    description: "",
    project_id: "",
    project_name: "",
    plot_id: "",
    plot_name: "",
  });

  const [deleteModalShow, setDeleteModalShow] = useState(false);
  const [expenseToDelete, setExpenseToDelete] = useState(null);
  const [categories, setCategories] = useState([]);
  const [bankAccounts, setBankAccounts] = useState([]);
  const [projects, setProjects] = useState([]);
  const [filteredPlots, setFilteredPlots] = useState([]);

  const [searchTerm, setSearchTerm] = useState({
    name: "",
    category: "",
    payee: "",
    type: "",
    amount: "",
    fromdate: "",
    todate: "",
  });

  const getAuthToken = () => localStorage.getItem("token");

  const [showMessageModal, setShowMessageModal] = useState(false);
  const [messageModalContent, setMessageModalContent] = useState({
    title: "",
    text: "",
    type: "",
  });

  const showCustomMessageModal = (title, text, type) => {
    setMessageModalContent({ title, text, type });
    setShowMessageModal(true);
  };

  const closeCustomMessageModal = () => {
    setShowMessageModal(false);
  };

  const formatText = (text) => {
    if (!text || typeof text !== "string") return "NA";
    return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
  };

  // ─── Projects fetch ───
  const fetchProjects = async () => {
    const token = getAuthToken();
    if (!token) return;

    try {
      const projectsResponse = await fetch(`${API_URL}/project-list-block`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const projectsData = await projectsResponse.json();

      if (projectsData.status) {
        setProjects(projectsData.data || []);
      }
    } catch (err) {
      console.error("Error fetching projects:", err);
    }
  };

  // ─── Plots fetch by project ───
  const fetchPlotsByProject = async (projectId) => {
    if (!projectId) {
      setFilteredPlots([]);
      return;
    }

    const token = getAuthToken();
    if (!token) return;

    try {
      const plotsResponse = await fetch(
        `${API_URL}/all-plot-list-by-id?project_id=${projectId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const plotsData = await plotsResponse.json();

      if (plotsData.status) {
        setFilteredPlots(plotsData.data || []);
      } else {
        setFilteredPlots([]);
      }
    } catch (err) {
      console.error("Error fetching plots:", err);
    }
  };

  // ─── Fetch expenses ───
  const fetchExpenses = async (page = 1) => {
    const token = getAuthToken();
    if (!token) {
      showCustomMessageModal(
        "Auth Error",
        "Authentication token not found. Please log in.",
        "error"
      );
      setLoading(false);
      setDataLoading(false);
      return;
    }
    setLoading(true);
    try {
      const query = new URLSearchParams({
        page,
        name: searchTerm.name,
        payee: searchTerm.payee,
        category: searchTerm.category,
        type: searchTerm.type,
        amount: searchTerm.amount,
        fromdate: searchTerm.fromdate,
        todate: searchTerm.todate,
      }).toString();

      const response = await fetch(`${API_URL}/expence-list?${query}`, {
        method: "GET",
        headers: { Authorization: `Bearer ${token}` },
      });

      if (!response.ok) {
        throw new Error("Failed to fetch expenses.");
      }
      const data = await response.json();
      if (data.status) {
        setExpenses(data.data);
        setTotalPages(data.totalPages || 1);
        setCurrentPage(data.currentPage || page);
      } else {
        showCustomMessageModal("Error", data.message, "error");
      }
    } catch (error) {
      console.error("Failed to fetch expenses:", error);
      showCustomMessageModal(
        "Network Error",
        "Could not connect to the server.",
        "error"
      );
    } finally {
      setLoading(false);
      setDataLoading(false);
    }
  };

  // ─── Fetch dropdown data ───
  const fetchDropdownData = async () => {
    const token = getAuthToken();
    if (!token) return;

    try {
      const [categoriesResponse, bankAccountsResponse] = await Promise.all([
        fetch(`${API_URL}/expence-category-list`, {
          headers: { Authorization: `Bearer ${token}` },
        }),
        fetch(`${API_URL}/expence-bank-account-list`, {
          headers: { Authorization: `Bearer ${token}` },
        }),
      ]);

      const categoriesData = await categoriesResponse.json();
      const bankAccountsData = await bankAccountsResponse.json();

      if (categoriesData.status) setCategories(categoriesData.data);
      if (bankAccountsData.status) setBankAccounts(bankAccountsData.data);
    } catch (error) {
      console.error("Failed to fetch dropdown data:", error);
    }
  };

  useEffect(() => {
    fetchExpenses(currentPage);
    fetchDropdownData();
    fetchProjects();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // ─── Export ───
  const exportAllToExcel = async () => {
    setExporting(true);
    try {
      const token = getAuthToken();
      if (!token) {
        showCustomMessageModal(
          "Authentication Error",
          "Authentication token not found. Please log in.",
          "error"
        );
        return;
      }

      const response = await fetch(`${API_URL}/expense-download`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        const errorData = await response.json();
        showCustomMessageModal(
          "Error",
          errorData.message || "Failed to fetch expenses.",
          "error"
        );
        return;
      }

      const data = await response.json();
      const allExpenses = data.data || [];
      const worksheet = XLSX.utils.json_to_sheet(
        allExpenses.map((expense, idx) => ({
          "SL No.": idx + 1,
          Name: expense.name,
          "Category Name": expense.category_name,
          Payee: expense.payee,
          Type: expense.type,
          Amount: expense.amount,
          Description: expense.description,
          Date: expense.date,
          Project: expense.project_name,
          Plot: expense.plot_name,
        }))
      );

      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Expenses");
      XLSX.writeFile(
        workbook,
        `All_Expenses_${new Date().toISOString().split("T")[0]}.xlsx`
      );
    } catch (err) {
      console.error("Export error:", err);
      showCustomMessageModal("Error", "Failed to export expenses.", "error");
    } finally {
      setExporting(false);
    }
  };

  const handleSearch = (e) => {
    e.preventDefault();
    fetchExpenses(1);
  };

  const handlePageChange = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      fetchExpenses(pageNumber);
    }
  };

  // ─── Edit modal ───
  const handleEditModalShow = (expense) => {
    setEditFormData({
      id: expense.id,
      category_id: expense.category_id,
      category_name: expense.category_name,
      account_id: expense.account_id,
      account_name: expense.account_name,
      type: expense.type,
      name: expense.name,
      amount: expense.amount,
      date: expense.date,
      description: expense.description,
      project_id: expense.project_id || "",
      project_name: expense.project_name || "",
      plot_id: expense.plot_id || "",
      plot_name: expense.plot_name || "",
    });

    if (expense.project_id) {
      fetchPlotsByProject(expense.project_id);
    } else {
      setFilteredPlots([]);
    }

    setEditModalShow(true);
  };

  const handleEditModalClose = () => {
    setEditModalShow(false);
    setFilteredPlots([]);
  };

  const handleEditFormChange = (e) => {
    const { name, value } = e.target;
    setEditFormData((prevData) => {
      const newData = { ...prevData, [name]: value };

      if (name === "category_id") {
        const selectedCategory = categories.find(
          (cat) => cat.id.toString() === value
        );
        newData.category_name = selectedCategory ? selectedCategory.name : "";
      }
      if (name === "account_id") {
        const selectedAccount = bankAccounts.find(
          (acc) => acc.id.toString() === value
        );
        newData.payee = selectedAccount ? selectedAccount.payee : "";
      }
      if (name === "project_id") {
        const selectedProject = projects.find(
          (project) => project.id.toString() === value
        );
        newData.project_name = selectedProject ? selectedProject.name : "";
        newData.plot_id = "";
        newData.plot_name = "";

        if (value) {
          fetchPlotsByProject(value);
        } else {
          setFilteredPlots([]);
        }
      }
      if (name === "plot_id") {
        const selectedPlot = filteredPlots.find(
          (plot) => plot.id.toString() === value
        );
        newData.plot_name = selectedPlot
          ? selectedPlot.name || selectedPlot.plot_number
          : "";
      }

      return newData;
    });
  };

  const handleEditSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const token = getAuthToken();

    const selectedProject = projects.find(
      (p) => p.id == editFormData.project_id
    );
    const selectedPlot = filteredPlots.find(
      (p) => p.id == editFormData.plot_id
    );

    const payload = {
      ...editFormData,
      amount: parseFloat(editFormData.amount),
      project_name: selectedProject ? selectedProject.name : "",
      plot_name: selectedPlot
        ? selectedPlot.name || selectedPlot.plot_number
        : "",
    };

    try {
      const response = await fetch(`${API_URL}/expence-update`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Failed to update expense.");
      }

      const result = await response.json();

      if (result.success == "1") {
        showCustomMessageModal("Success", result.message, "success");
        handleEditModalClose();
        fetchExpenses(currentPage);
      } else {
        throw new Error(result.message || "Failed to update expense.");
      }
    } catch (error) {
      console.error("Error updating expense:", error);
      showCustomMessageModal(
        "Error",
        error.message || "An unexpected error occurred.",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  // ─── Delete ───
  const handleDeleteModalShow = (expenseId) => {
    setExpenseToDelete(expenseId);
    setDeleteModalShow(true);
  };

  const handleDeleteModalClose = () => {
    setDeleteModalShow(false);
    setExpenseToDelete(null);
  };

  const handleConfirmDelete = async () => {
    setLoading(true);
    const token = getAuthToken();

    try {
      const response = await fetch(`${API_URL}/expence-delete`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ id: expenseToDelete }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Failed to delete expense.");
      }

      const result = await response.json();
      showCustomMessageModal("Success", result.message, "success");
      handleDeleteModalClose();
      fetchExpenses(currentPage);
    } catch (error) {
      console.error("Error deleting expense:", error);
      showCustomMessageModal(
        "Error",
        error.message || "An unexpected error occurred.",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  const handleToggle = () => setIsFilterActive(!isFilterActive);

  // ─── Pagination numbers ───
  const getPageNumbers = () => {
    const pages = [];
    const showEllipsis = totalPages > 7;
    pages.push(1);
    if (showEllipsis && currentPage > 4) pages.push("left-ellipsis");
    const start = Math.max(2, currentPage - 2);
    const end = Math.min(totalPages - 1, currentPage + 2);
    for (let i = start; i <= end; i++) pages.push(i);
    if (showEllipsis && currentPage < totalPages - 3) pages.push("right-ellipsis");
    if (totalPages > 1) pages.push(totalPages);
    return pages;
  };

  // ═══════════════════════════════════════════
  // 🎨 RENDER
  // ═══════════════════════════════════════════
  return (
    <>
      <div
        style={{
          minHeight: "100vh",
          background: "linear-gradient(135deg, #f0f6ff 0%, #e6f0fa 100%)",
          padding: "24px",
          fontFamily: "'Poppins', 'DM Sans', sans-serif",
        }}
      >
        <div style={{ maxWidth: "1500px", margin: "0 auto" }}>
          {/* ═══════ HEADER CARD ═══════ */}
          <div
            style={{
              background: "#ffffff",
              borderRadius: "20px",
              boxShadow: "0 12px 40px rgba(30, 87, 153, 0.1)",
              border: "1.5px solid #e2e8f0",
              padding: "24px 30px",
              display: "flex",
              alignItems: "center",
              gap: "16px",
              marginBottom: "20px",
              flexWrap: "wrap",
              position: "relative",
              overflow: "hidden",
            }}
          >
            <div
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                height: "5px",
                background: "linear-gradient(90deg, #1e5799, #2b6cb0, #1e5799)",
              }}
            />
            <div
              style={{
                width: "56px",
                height: "56px",
                borderRadius: "16px",
                background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#ffffff",
                fontSize: "26px",
                boxShadow: "0 8px 20px rgba(30, 87, 153, 0.3)",
                flexShrink: 0,
              }}
            >
              📋
            </div>
            <div style={{ flex: 1, minWidth: "200px" }}>
              <h1
                style={{
                  margin: 0,
                  fontSize: "24px",
                  fontWeight: "800",
                  color: "#1e3a5f",
                  letterSpacing: "-0.5px",
                }}
              >
                Expenses List
              </h1>
              <p
                style={{
                  margin: "3px 0 0",
                  fontSize: "13px",
                  color: "#64748b",
                  fontWeight: "500",
                }}
              >
                View, filter and export all your expenses
              </p>
            </div>

            <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
              {/* Export Button */}
              <button
                onClick={exportAllToExcel}
                disabled={exporting}
                style={{
                  padding: "10px 20px",
                  borderRadius: "10px",
                  border: "none",
                  background: exporting
                    ? "#cbd5e1"
                    : "linear-gradient(135deg, #059669, #10b981)",
                  color: "#ffffff",
                  fontSize: "13px",
                  fontWeight: "700",
                  cursor: exporting ? "not-allowed" : "pointer",
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "8px",
                  boxShadow: exporting
                    ? "none"
                    : "0 6px 18px rgba(5, 150, 105, 0.3)",
                  transition: "all 0.2s ease",
                }}
              >
                {exporting ? (
                  <>
                    <span
                      style={{
                        width: "14px",
                        height: "14px",
                        border: "2px solid rgba(255,255,255,0.3)",
                        borderTop: "2px solid #ffffff",
                        borderRadius: "50%",
                        display: "inline-block",
                        animation: "spin 0.8s linear infinite",
                      }}
                    />
                    Exporting...
                  </>
                ) : (
                  <>
                    <FaDownload /> Export
                  </>
                )}
              </button>

              {/* Add Button */}
              <Link
                to="/expence-add"
                style={{
                  padding: "10px 20px",
                  borderRadius: "10px",
                  border: "none",
                  background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
                  color: "#ffffff",
                  fontSize: "13px",
                  fontWeight: "700",
                  textDecoration: "none",
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "8px",
                  boxShadow: "0 6px 18px rgba(30, 87, 153, 0.3)",
                }}
              >
                <FaPlus /> Add Expense
              </Link>

              {/* Filter Toggle */}
              <button
                onClick={handleToggle}
                title={isFilterActive ? "Hide Filters" : "Show Filters"}
                style={{
                  width: "42px",
                  height: "42px",
                  borderRadius: "10px",
                  border: "1.5px solid #e2e8f0",
                  background: isFilterActive ? "#1e5799" : "#ffffff",
                  color: isFilterActive ? "#ffffff" : "#1e3a5f",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "18px",
                  cursor: "pointer",
                  transition: "all 0.25s ease",
                  boxShadow: isFilterActive
                    ? "0 6px 18px rgba(30, 87, 153, 0.3)"
                    : "none",
                }}
              >
                {isFilterActive ? <MdFilterAltOff /> : <MdFilterAlt />}
              </button>
            </div>
          </div>

          {/* ═══════ MAIN CARD ═══════ */}
          <div
            style={{
              background: "#ffffff",
              borderRadius: "20px",
              boxShadow: "0 12px 40px rgba(30, 87, 153, 0.1)",
              border: "1.5px solid #e2e8f0",
              overflow: "hidden",
            }}
          >
            <div
              style={{
                height: "5px",
                background: "linear-gradient(90deg, #1e5799, #2b6cb0, #1e5799)",
              }}
            />

            <div style={{ padding: "24px 30px" }}>
              {/* ═══════ FILTER PANEL ═══════ */}
              {isFilterActive && (
                <div
                  style={{
                    background:
                      "linear-gradient(135deg, #f8fafc, #f0f6ff)",
                    border: "1.5px dashed #cbd5e1",
                    borderRadius: "14px",
                    padding: "20px",
                    marginBottom: "24px",
                  }}
                >
                  <Row className="gy-3">
                    <Col md={6} lg={4}>
                      <input
                        type="text"
                        name="name"
                        placeholder="Search by Name"
                        className="form-control"
                        style={inputStyle}
                        value={searchTerm.name}
                        onChange={(e) =>
                          setSearchTerm({
                            ...searchTerm,
                            [e.target.name]: e.target.value,
                          })
                        }
                      />
                    </Col>

                    <Col md={6} lg={4}>
                      <input
                        type="text"
                        name="payee"
                        placeholder="Search by Payee"
                        className="form-control"
                        style={inputStyle}
                        value={searchTerm.payee}
                        onChange={(e) =>
                          setSearchTerm({
                            ...searchTerm,
                            [e.target.name]: e.target.value,
                          })
                        }
                      />
                    </Col>

                    <Col md={6} lg={4}>
                      <select
                        name="category"
                        className="form-control"
                        style={inputStyle}
                        value={searchTerm.category}
                        onChange={(e) =>
                          setSearchTerm({
                            ...searchTerm,
                            [e.target.name]: e.target.value,
                          })
                        }
                      >
                        <option value="">All Categories</option>
                        {categories.map((category) => (
                          <option key={category.id} value={category.name}>
                            {category.name}
                          </option>
                        ))}
                      </select>
                    </Col>

                    <Col md={6} lg={4}>
                      <select
                        name="type"
                        className="form-control"
                        style={inputStyle}
                        value={searchTerm.type}
                        onChange={(e) =>
                          setSearchTerm({
                            ...searchTerm,
                            [e.target.name]: e.target.value,
                          })
                        }
                      >
                        <option value="">All Types</option>
                        <option value="online">Online</option>
                        <option value="cash">Cash</option>
                      </select>
                    </Col>

                    <Col md={6} lg={4}>
                      <input
                        type="date"
                        name="fromdate"
                        className="form-control"
                        style={inputStyle}
                        value={searchTerm.fromdate}
                        onChange={(e) =>
                          setSearchTerm({
                            ...searchTerm,
                            [e.target.name]: e.target.value,
                          })
                        }
                      />
                    </Col>

                    <Col md={6} lg={4}>
                      <input
                        type="date"
                        name="todate"
                        className="form-control"
                        style={inputStyle}
                        value={searchTerm.todate}
                        onChange={(e) =>
                          setSearchTerm({
                            ...searchTerm,
                            [e.target.name]: e.target.value,
                          })
                        }
                      />
                    </Col>

                    <Col md={12}>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "flex-end",
                          gap: "10px",
                          paddingTop: "6px",
                        }}
                      >
                        <button
                          type="button"
                          onClick={() => {
                            setSearchTerm({
                              name: "",
                              category: "",
                              payee: "",
                              type: "",
                              amount: "",
                              fromdate: "",
                              todate: "",
                            });
                          }}
                          style={{
                            padding: "10px 20px",
                            borderRadius: "10px",
                            border: "1.5px solid #e2e8f0",
                            background: "#ffffff",
                            color: "#64748b",
                            fontSize: "13px",
                            fontWeight: "700",
                            cursor: "pointer",
                          }}
                        >
                          Clear
                        </button>
                        <button
                          type="button"
                          onClick={handleSearch}
                          style={{
                            padding: "10px 26px",
                            borderRadius: "10px",
                            border: "none",
                            background:
                              "linear-gradient(135deg, #1e5799, #2b6cb0)",
                            color: "#ffffff",
                            fontSize: "13px",
                            fontWeight: "700",
                            cursor: "pointer",
                            boxShadow: "0 4px 12px rgba(30, 87, 153, 0.3)",
                          }}
                        >
                          🔍 Search
                        </button>
                      </div>
                    </Col>
                  </Row>
                </div>
              )}

              {/* ═══════ TABLE ═══════ */}
              {dataLoading ? (
                <div
                  style={{
                    textAlign: "center",
                    padding: "70px 20px",
                    color: "#64748b",
                  }}
                >
                  <div
                    style={{
                      width: "44px",
                      height: "44px",
                      border: "3px solid #cbd5e1",
                      borderTop: "3px solid #2b6cb0",
                      borderRadius: "50%",
                      display: "inline-block",
                      animation: "spin 0.8s linear infinite",
                    }}
                  />
                  <p
                    style={{
                      marginTop: "18px",
                      fontSize: "14px",
                      fontWeight: "600",
                    }}
                  >
                    Loading expenses...
                  </p>
                </div>
              ) : (
                <>
                  <div
                    style={{
                      overflowX: "auto",
                      overflowY: "visible",
                      borderRadius: "14px",
                      border: "1.5px solid #e2e8f0",
                    }}
                  >
                    <table
                      style={{
                        width: "100%",
                        minWidth: "1300px",
                        borderCollapse: "collapse",
                        fontSize: "12.5px",
                      }}
                    >
                      <thead>
                        <tr
                          style={{
                            background:
                              "linear-gradient(135deg, #1e5799, #2b6cb0)",
                          }}
                        >
                          {[
                            "S.N",
                            "Category",
                            "Cat. Type",
                            "Payee",
                            "Payment Mode",
                            "Expense Date",
                            "Pay Date",
                            "Project",
                            "Unit",
                            "Description",
                            "CR Amount",
                            "DR Amount",
                            "Balance",
                            "Actions",
                          ].map((th, i) => (
                            <th
                              key={i}
                              style={{
                                padding: "14px 12px",
                                color: "#ffffff",
                                fontWeight: "700",
                                fontSize: "11px",
                                textAlign: "left",
                                letterSpacing: "0.5px",
                                textTransform: "uppercase",
                                whiteSpace: "nowrap",
                              }}
                            >
                              {th}
                            </th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {expenses.length > 0 ? (
                          expenses.map((expense, index) => (
                            <tr
                              key={expense.id}
                              style={{ borderBottom: "1px solid #f1f5f9" }}
                              onMouseEnter={(e) =>
                                (e.currentTarget.style.background = "#f8fafc")
                              }
                              onMouseLeave={(e) =>
                                (e.currentTarget.style.background =
                                  "transparent")
                              }
                            >
                              <td
                                style={{
                                  padding: "12px",
                                  fontWeight: "700",
                                  color: "#1e5799",
                                }}
                              >
                                {(currentPage - 1) * limit + (index + 1)}
                              </td>
                              <td
                                style={{
                                  padding: "12px",
                                  fontWeight: "600",
                                  color: "#1e3a5f",
                                }}
                              >
                                {expense.category_name}
                              </td>
                              <td style={{ padding: "12px" }}>
                                <span
                                  style={{
                                    display: "inline-block",
                                    padding: "4px 10px",
                                    borderRadius: "20px",
                                    fontSize: "10.5px",
                                    fontWeight: "700",
                                    background:
                                      expense.category_type === "cr"
                                        ? "#e7f9eb"
                                        : expense.category_type === "dr"
                                          ? "#feeaeb"
                                          : "#f1f5f9",
                                    color:
                                      expense.category_type === "cr"
                                        ? "#059669"
                                        : expense.category_type === "dr"
                                          ? "#dc2626"
                                          : "#64748b",
                                    textTransform: "uppercase",
                                  }}
                                >
                                  {expense.category_type || "NA"}
                                </span>
                              </td>
                              <td
                                style={{
                                  padding: "12px",
                                  color: "#334155",
                                  fontWeight: "500",
                                }}
                              >
                                {formatText(expense.payee)}
                              </td>
                              <td style={{ padding: "12px" }}>
                                <span
                                  style={{
                                    display: "inline-block",
                                    padding: "4px 10px",
                                    borderRadius: "20px",
                                    fontSize: "10.5px",
                                    fontWeight: "700",
                                    background:
                                      expense.type === "online"
                                        ? "#e8f1fb"
                                        : "#fef3c7",
                                    color:
                                      expense.type === "online"
                                        ? "#1e5799"
                                        : "#d97706",
                                    textTransform: "capitalize",
                                  }}
                                >
                                  {expense.type}
                                </span>
                              </td>
                              <td
                                style={{
                                  padding: "12px",
                                  color: "#64748b",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                {(() => {
                                  const d = new Date(expense.date);
                                  const day = String(d.getDate()).padStart(
                                    2,
                                    "0"
                                  );
                                  const month = String(
                                    d.getMonth() + 1
                                  ).padStart(2, "0");
                                  const year = d.getFullYear();
                                  return `${day}-${month}-${year}`;
                                })()}
                              </td>
                              <td
                                style={{
                                  padding: "12px",
                                  color: "#64748b",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                {(() => {
                                  const d = new Date(expense.created_at);
                                  const day = String(d.getDate()).padStart(
                                    2,
                                    "0"
                                  );
                                  const month = String(
                                    d.getMonth() + 1
                                  ).padStart(2, "0");
                                  const year = d.getFullYear();
                                  return `${day}-${month}-${year}`;
                                })()}
                              </td>
                              <td style={{ padding: "12px", color: "#334155" }}>
                                {expense.project_name || "NA"}
                              </td>
                              <td style={{ padding: "12px", color: "#334155" }}>
                                {expense.plot_name || "NA"}
                              </td>
                              <td
                                style={{
                                  padding: "12px",
                                  color: "#64748b",
                                  maxWidth: "180px",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap",
                                }}
                                title={expense.description || "NA"}
                              >
                                {expense.description
                                  ? expense.description
                                      .charAt(0)
                                      .toUpperCase() +
                                    expense.description
                                      .slice(1)
                                      .toLowerCase()
                                  : "NA"}
                              </td>
                              <td style={{ padding: "12px" }}>
                                {expense.category_type === "cr" ? (
                                  <span
                                    style={{
                                      color: "#059669",
                                      fontWeight: "800",
                                    }}
                                  >
                                    ₹ {expense.amount}
                                  </span>
                                ) : (
                                  <span style={{ color: "#cbd5e1" }}>—</span>
                                )}
                              </td>
                              <td style={{ padding: "12px" }}>
                                {expense.category_type === "dr" ? (
                                  <span
                                    style={{
                                      color: "#dc2626",
                                      fontWeight: "800",
                                    }}
                                  >
                                    ₹ {expense.amount}
                                  </span>
                                ) : (
                                  <span style={{ color: "#cbd5e1" }}>—</span>
                                )}
                              </td>
                              <td style={{ padding: "12px" }}>
                                <span
                                  style={{
                                    color:
                                      expense.running_balance >= 0
                                        ? "#059669"
                                        : "#dc2626",
                                    fontWeight: "800",
                                  }}
                                >
                                  ₹{" "}
                                  {expense.running_balance?.toLocaleString() ||
                                    0}
                                </span>
                              </td>
                              <td style={{ padding: "12px" }}>
                                <div className="dropdown">
                                  <button
                                    className="btn dropdown-toggle"
                                    type="button"
                                    data-bs-toggle="dropdown"
                                    data-bs-boundary="viewport"
                                    data-bs-popper-config='{"strategy":"fixed"}'
                                    aria-expanded="false"
                                    style={{
                                      background: "#f8fafc",
                                      border: "1.5px solid #e2e8f0",
                                      borderRadius: "8px",
                                      width: "36px",
                                      height: "36px",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      color: "#1e5799",
                                      padding: 0,
                                    }}
                                  >
                                    <BsThreeDots size={18} />
                                  </button>
                                  <ul
                                    className="dropdown-menu"
                                    style={{
                                      zIndex: 9999,
                                      borderRadius: "14px",
                                      border: "none",
                                      padding: "8px",
                                      boxShadow:
                                        "0 12px 40px rgba(30, 87, 153, 0.18), 0 4px 12px rgba(0,0,0,0.06)",
                                      minWidth: "220px",
                                      marginTop: "8px",
                                      background: "#ffffff",
                                    }}
                                  >
                                    <li>
                                      <button
                                        className="dropdown-item"
                                        onClick={() =>
                                          handleEditModalShow(expense)
                                        }
                                        style={dropdownItem}
                                        onMouseEnter={(e) => {
                                          e.currentTarget.style.background =
                                            "#e8f1fb";
                                          e.currentTarget.style.transform =
                                            "translateX(3px)";
                                        }}
                                        onMouseLeave={(e) => {
                                          e.currentTarget.style.background =
                                            "transparent";
                                          e.currentTarget.style.transform =
                                            "translateX(0)";
                                        }}
                                      >
                                        <span
                                          style={iconBadge(
                                            "#e8f1fb",
                                            "#1e5799"
                                          )}
                                        >
                                          <FaEdit size={13} />
                                        </span>
                                        Edit Expense
                                      </button>
                                    </li>
                                    <li>
                                      <hr
                                        style={{
                                          margin: "6px 8px",
                                          border: "none",
                                          borderTop: "1.5px dashed #e2e8f0",
                                        }}
                                      />
                                    </li>
                                    <li>
                                      <button
                                        className="dropdown-item"
                                        onClick={() =>
                                          handleDeleteModalShow(expense.id)
                                        }
                                        style={{
                                          ...dropdownItem,
                                          color: "#dc2626",
                                        }}
                                        onMouseEnter={(e) => {
                                          e.currentTarget.style.background =
                                            "#feeaeb";
                                          e.currentTarget.style.transform =
                                            "translateX(3px)";
                                        }}
                                        onMouseLeave={(e) => {
                                          e.currentTarget.style.background =
                                            "transparent";
                                          e.currentTarget.style.transform =
                                            "translateX(0)";
                                        }}
                                      >
                                        <span
                                          style={iconBadge(
                                            "#feeaeb",
                                            "#dc2626"
                                          )}
                                        >
                                          <RiDeleteBin3Fill size={13} />
                                        </span>
                                        Delete Expense
                                      </button>
                                    </li>
                                  </ul>
                                </div>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td
                              colSpan="14"
                              style={{
                                textAlign: "center",
                                padding: "50px",
                                color: "#94a3b8",
                                fontWeight: "600",
                              }}
                            >
                              📭 No expenses found.
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>

                  {/* ═══════ PAGINATION ═══════ */}
                  {totalPages > 1 && (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        marginTop: "24px",
                        gap: "6px",
                        flexWrap: "wrap",
                      }}
                    >
                      <button
                        onClick={() => handlePageChange(currentPage - 1)}
                        disabled={currentPage === 1}
                        style={{
                          padding: "8px 14px",
                          borderRadius: "10px",
                          border: "1.5px solid #e2e8f0",
                          background: "#ffffff",
                          color: currentPage === 1 ? "#cbd5e1" : "#1e5799",
                          fontWeight: "700",
                          fontSize: "13px",
                          cursor:
                            currentPage === 1 ? "not-allowed" : "pointer",
                          display: "inline-flex",
                          alignItems: "center",
                          gap: "6px",
                        }}
                      >
                        ‹ Prev
                      </button>

                      {getPageNumbers().map((p, i) => {
                        if (
                          p === "left-ellipsis" ||
                          p === "right-ellipsis"
                        ) {
                          return (
                            <span
                              key={`ellipsis-${i}`}
                              style={{
                                padding: "0 6px",
                                color: "#94a3b8",
                                fontWeight: "700",
                              }}
                            >
                              ...
                            </span>
                          );
                        }
                        const isActive = p === currentPage;
                        return (
                          <button
                            key={p}
                            onClick={() => handlePageChange(p)}
                            style={{
                              minWidth: "38px",
                              height: "38px",
                              borderRadius: "10px",
                              border: isActive
                                ? "none"
                                : "1.5px solid #e2e8f0",
                              background: isActive
                                ? "linear-gradient(135deg, #1e5799, #2b6cb0)"
                                : "#ffffff",
                              color: isActive ? "#ffffff" : "#334155",
                              fontWeight: "700",
                              fontSize: "13px",
                              cursor: "pointer",
                              boxShadow: isActive
                                ? "0 6px 16px rgba(30, 87, 153, 0.3)"
                                : "none",
                              transition: "all 0.18s ease",
                            }}
                          >
                            {p}
                          </button>
                        );
                      })}

                      <button
                        onClick={() => handlePageChange(currentPage + 1)}
                        disabled={currentPage === totalPages}
                        style={{
                          padding: "8px 14px",
                          borderRadius: "10px",
                          border: "1.5px solid #e2e8f0",
                          background: "#ffffff",
                          color:
                            currentPage === totalPages ? "#cbd5e1" : "#1e5799",
                          fontWeight: "700",
                          fontSize: "13px",
                          cursor:
                            currentPage === totalPages
                              ? "not-allowed"
                              : "pointer",
                          display: "inline-flex",
                          alignItems: "center",
                          gap: "6px",
                        }}
                      >
                        Next ›
                      </button>
                    </div>
                  )}

                  {expenses.length > 0 && (
                    <p
                      style={{
                        textAlign: "center",
                        fontSize: "12px",
                        color: "#94a3b8",
                        marginTop: "12px",
                        marginBottom: 0,
                        fontWeight: "500",
                      }}
                    >
                      Page {currentPage} of {totalPages}
                    </p>
                  )}
                </>
              )}
            </div>
          </div>

          {/* Footer Copyright */}
          <p
            style={{
              textAlign: "center",
              color: "#94a3b8",
              fontSize: "12.5px",
              marginTop: "24px",
              fontWeight: "500",
            }}
          >
            © {new Date().getFullYear()} A2 Demo Real Estates Pvt Ltd. All
            Rights Reserved.
          </p>
        </div>
      </div>

      {/* ═══════════════════════════════════════════ */}
      {/* 🎯 EDIT EXPENSE MODAL */}
      {/* ═══════════════════════════════════════════ */}
      <Modal
        show={editModalShow}
        onHide={handleEditModalClose}
        centered
        size="lg"
        backdrop="static"
        style={{ zIndex: 99999 }}
      >
        <Modal.Header
          closeButton
          style={{
            background: "#1e5799",
            color: "#ffffff",
            border: "none",
            padding: "18px 24px",
          }}
        >
          <Modal.Title style={{ fontWeight: "800", fontSize: "18px" }}>
            ✏️ Edit Expense
          </Modal.Title>
        </Modal.Header>
        <Form onSubmit={handleEditSubmit}>
          <Modal.Body
            style={{ padding: "24px", maxHeight: "70vh", overflowY: "auto" }}
          >
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label style={labelStyle}>Category</Form.Label>
                  <Form.Control
                    as="select"
                    name="category_id"
                    value={editFormData.category_id}
                    onChange={handleEditFormChange}
                    required
                    style={inputStyle}
                  >
                    <option value="">Select Category</option>
                    {categories?.map((cat) => (
                      <option key={cat.id} value={cat.id}>
                        {cat.name}
                      </option>
                    ))}
                  </Form.Control>
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label style={labelStyle}>Select Account</Form.Label>
                  <Form.Control
                    as="select"
                    name="account_id"
                    value={editFormData.account_id}
                    onChange={handleEditFormChange}
                    required
                    style={inputStyle}
                  >
                    <option value="">Select Account</option>
                    {bankAccounts?.map((acc) => (
                      <option key={acc.id} value={acc.id}>
                        {acc.name} ({acc.payee})
                      </option>
                    ))}
                  </Form.Control>
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label style={labelStyle}>Project Name</Form.Label>
                  <Form.Control
                    as="select"
                    name="project_id"
                    value={editFormData.project_id}
                    onChange={handleEditFormChange}
                    style={inputStyle}
                  >
                    <option value="">Select Project</option>
                    {projects?.map((project) => (
                      <option key={project.id} value={project.id}>
                        {project.name}
                      </option>
                    ))}
                  </Form.Control>
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label style={labelStyle}>Unit Number</Form.Label>
                  <Form.Control
                    as="select"
                    name="plot_id"
                    value={editFormData.plot_id}
                    onChange={handleEditFormChange}
                    disabled={!editFormData.project_id}
                    style={{
                      ...inputStyle,
                      background: !editFormData.project_id
                        ? "#f8fafc"
                        : "#ffffff",
                      cursor: !editFormData.project_id
                        ? "not-allowed"
                        : "pointer",
                    }}
                  >
                    <option value="">Select Unit</option>
                    {filteredPlots?.map((plot) => (
                      <option key={plot.id} value={plot.id}>
                        {plot.plot_shop_villa_no || `Plot ${plot.id}`}
                      </option>
                    ))}
                  </Form.Control>
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label style={labelStyle}>Receiver Name</Form.Label>
                  <Form.Control
                    type="text"
                    name="name"
                    value={editFormData.name}
                    onChange={handleEditFormChange}
                    required
                    style={inputStyle}
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label style={labelStyle}>Amount (₹)</Form.Label>
                  <Form.Control
                    type="number"
                    name="amount"
                    value={editFormData.amount}
                    onChange={handleEditFormChange}
                    required
                    style={inputStyle}
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label style={labelStyle}>Type</Form.Label>
                  <Form.Control
                    type="text"
                    name="type"
                    value={editFormData.type}
                    onChange={handleEditFormChange}
                    readOnly
                    style={{
                      ...inputStyle,
                      background: "#f8fafc",
                      cursor: "not-allowed",
                    }}
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label style={labelStyle}>Date</Form.Label>
                  <Form.Control
                    type="date"
                    name="date"
                    value={editFormData.date}
                    onChange={handleEditFormChange}
                    required
                    style={inputStyle}
                  />
                </Form.Group>
              </Col>
              <Col md={12}>
                <Form.Group className="mb-3">
                  <Form.Label style={labelStyle}>Description</Form.Label>
                  <Form.Control
                    as="textarea"
                    name="description"
                    rows={3}
                    value={editFormData.description}
                    onChange={handleEditFormChange}
                    style={{ ...inputStyle, resize: "none" }}
                  />
                </Form.Group>
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer
            style={{
              borderTop: "1.5px solid #e2e8f0",
              padding: "16px 24px",
              gap: "10px",
            }}
          >
            <button
              type="button"
              onClick={handleEditModalClose}
              style={{
                padding: "10px 22px",
                borderRadius: "10px",
                border: "1.5px solid #e2e8f0",
                background: "#ffffff",
                color: "#64748b",
                fontSize: "13px",
                fontWeight: "700",
                cursor: "pointer",
              }}
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={loading}
              style={{
                padding: "10px 22px",
                borderRadius: "10px",
                border: "none",
                background: loading
                  ? "#cbd5e1"
                  : "linear-gradient(135deg, #1e5799, #2b6cb0)",
                color: "#ffffff",
                fontSize: "13px",
                fontWeight: "700",
                cursor: loading ? "not-allowed" : "pointer",
                boxShadow: loading
                  ? "none"
                  : "0 4px 12px rgba(30, 87, 153, 0.3)",
                display: "inline-flex",
                alignItems: "center",
                gap: "8px",
              }}
            >
              {loading ? (
                <>
                  <span
                    style={{
                      width: "14px",
                      height: "14px",
                      border: "2px solid rgba(255,255,255,0.3)",
                      borderTop: "2px solid #ffffff",
                      borderRadius: "50%",
                      display: "inline-block",
                      animation: "spin 0.8s linear infinite",
                    }}
                  />
                  Saving...
                </>
              ) : (
                "Save Changes"
              )}
            </button>
          </Modal.Footer>
        </Form>
      </Modal>

      {/* ═══════════════════════════════════════════ */}
      {/* 🎯 DELETE CONFIRM MODAL */}
      {/* ═══════════════════════════════════════════ */}
      <Modal
        show={deleteModalShow}
        onHide={handleDeleteModalClose}
        centered
        backdrop="static"
        style={{ zIndex: 99999 }}
      >
        <Modal.Header
          closeButton
          style={{
            background: "#dc2626",
            color: "#ffffff",
            border: "none",
            padding: "18px 24px",
          }}
        >
          <Modal.Title style={{ fontWeight: "800", fontSize: "18px" }}>
            ⚠️ Confirm Deletion
          </Modal.Title>
        </Modal.Header>
        <Modal.Body
          style={{ padding: "24px", fontSize: "14px", color: "#334155" }}
        >
          Are you sure you want to delete this expense? This action cannot be
          undone.
        </Modal.Body>
        <Modal.Footer
          style={{
            borderTop: "1.5px solid #e2e8f0",
            padding: "16px 24px",
            gap: "10px",
          }}
        >
          <button
            type="button"
            onClick={handleDeleteModalClose}
            style={{
              padding: "10px 22px",
              borderRadius: "10px",
              border: "1.5px solid #e2e8f0",
              background: "#ffffff",
              color: "#64748b",
              fontSize: "13px",
              fontWeight: "700",
              cursor: "pointer",
            }}
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={handleConfirmDelete}
            disabled={loading}
            style={{
              padding: "10px 22px",
              borderRadius: "10px",
              border: "none",
              background: loading
                ? "#cbd5e1"
                : "linear-gradient(135deg, #dc2626, #b91c1c)",
              color: "#ffffff",
              fontSize: "13px",
              fontWeight: "700",
              cursor: loading ? "not-allowed" : "pointer",
              boxShadow: loading
                ? "none"
                : "0 4px 12px rgba(220, 38, 38, 0.3)",
              display: "inline-flex",
              alignItems: "center",
              gap: "8px",
            }}
          >
            {loading ? (
              <>
                <span
                  style={{
                    width: "14px",
                    height: "14px",
                    border: "2px solid rgba(255,255,255,0.3)",
                    borderTop: "2px solid #ffffff",
                    borderRadius: "50%",
                    display: "inline-block",
                    animation: "spin 0.8s linear infinite",
                  }}
                />
                Deleting...
              </>
            ) : (
              "Delete"
            )}
          </button>
        </Modal.Footer>
      </Modal>

      {/* ═══════════════════════════════════════════ */}
      {/* 🎯 MESSAGE MODAL */}
      {/* ═══════════════════════════════════════════ */}
      {showMessageModal && (
        <div
          className="modal d-block"
          tabIndex="-1"
          style={{
            backgroundColor: "rgba(15, 23, 42, 0.6)",
            backdropFilter: "blur(4px)",
            zIndex: 99999,
          }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div
              style={{
                background: "#ffffff",
                borderRadius: "20px",
                overflow: "hidden",
                border: "none",
                boxShadow: "0 24px 60px rgba(0,0,0,0.2)",
              }}
            >
              <div
                style={{
                  height: "5px",
                  background:
                    messageModalContent.type === "success"
                      ? "linear-gradient(90deg, #059669, #10b981)"
                      : "linear-gradient(90deg, #dc2626, #ef4444)",
                }}
              />

              <div
                style={{
                  padding: "24px 24px 16px",
                  display: "flex",
                  alignItems: "center",
                  gap: "14px",
                }}
              >
                <div
                  style={{
                    width: "48px",
                    height: "48px",
                    borderRadius: "14px",
                    background:
                      messageModalContent.type === "success"
                        ? "linear-gradient(135deg, #f0fdf4, #dcfce7)"
                        : "linear-gradient(135deg, #feeaeb, #fecaca)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "24px",
                    flexShrink: 0,
                  }}
                >
                  {messageModalContent.type === "success" ? "✓" : "✕"}
                </div>
                <div style={{ flex: 1 }}>
                  <h5
                    style={{
                      margin: 0,
                      fontSize: "16px",
                      fontWeight: "800",
                      color:
                        messageModalContent.type === "success"
                          ? "#059669"
                          : "#dc2626",
                    }}
                  >
                    {messageModalContent.title}
                  </h5>
                </div>
                <button
                  type="button"
                  onClick={closeCustomMessageModal}
                  style={{
                    width: "32px",
                    height: "32px",
                    borderRadius: "10px",
                    border: "1.5px solid #e2e8f0",
                    background: "#ffffff",
                    color: "#64748b",
                    fontSize: "16px",
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                  }}
                >
                  ×
                </button>
              </div>

              <div
                style={{
                  padding: "0 24px 24px 86px",
                  fontSize: "13.5px",
                  color: "#334155",
                  fontWeight: "500",
                  lineHeight: "1.6",
                }}
              >
                {messageModalContent.text}
              </div>

              <div
                style={{
                  padding: "16px 24px",
                  background: "#f8fafc",
                  borderTop: "1.5px solid #e2e8f0",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <button
                  type="button"
                  onClick={closeCustomMessageModal}
                  style={{
                    padding: "10px 36px",
                    borderRadius: "10px",
                    border: "none",
                    background:
                      messageModalContent.type === "success"
                        ? "linear-gradient(135deg, #059669, #10b981)"
                        : "linear-gradient(135deg, #dc2626, #ef4444)",
                    color: "#ffffff",
                    fontSize: "13.5px",
                    fontWeight: "800",
                    cursor: "pointer",
                    boxShadow:
                      messageModalContent.type === "success"
                        ? "0 4px 14px rgba(5, 150, 105, 0.3)"
                        : "0 4px 14px rgba(220, 38, 38, 0.3)",
                  }}
                >
                  OK
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      <style>{`
        @keyframes spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
      `}</style>
    </>
  );
}

export default ExpensesList;
